import { createReducer } from '@reduxjs/toolkit';

import getCarYearList from '../../thunks/general/getCarYearList';

const initialState = {
  loading: false,
  error: null,
  list: [],
  total: 0
};

const getCarYearListReducer = createReducer(initialState, {
  [getCarYearList.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getCarYearList.fulfilled]: (state, { payload: { data, total } }) => ({
    ...state,
    list: data.map(({ year }) => ({ label: year, value: year })),
    loading: false,
    total
  }),
  [getCarYearList.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
});

export default getCarYearListReducer;
